import React from 'react'
import QuickReply from '../components/QuickReply'

const QuickReplyBanner = ({ choices }) => {
  return (
    <QuickReply message={choices} />
  )
}

export default QuickReplyBanner



// WEBPACK FOOTER //
// ./src/views/layouts/QuickReplyBanner.js